import { ThemeType } from '../types.js';
const name = 'saints';
const displayName = 'Southampton';
const type = ThemeType.Club;
const socials = {
    facebookUrl: 'https://www.facebook.com/profile.php?id=61586107954371',
    // etc.
};
// TODO: Move to CMS
const assets = {
    favicon: '/assets/images/saints/favicon.ico',
    logo: '/assets/images/saints/logo.svg',
    logoLight: '/assets/images/saints/logo-light.svg',
    logoMobile: '/assets/images/saints/logo-mobile.svg',
    logoBanner: '/assets/images/saints/logo.png',
    logoCard: '/assets/images/saints/logo.svg',
    loserImage: '/assets/images/saints/non-winner.webp',
    banner: '/assets/images/saints/banner.webp',
    partners: [
        '/assets/images/partners/saints/1.png',
        '/assets/images/partners/saints/2.png',
        '/assets/images/partners/saints/4.png',
        '/assets/images/partners/saints/5.png',
    ],
};
const primitives = {
    theme: {
        extend: {
            colors: {
                white: '#F8FAFC',
                'pure-white': '#FFFFFF',
                primary: '#000000', // black
                'primary-light': '#FFD6DE', // lighter red
                'primary-lighter': '#FFD6DE', // lighter red
                secondary: '#C70128', // red
                'secondary-dark': '#C70128', // red
                'secondary-light': '#C70128', // red
                tertiary: '#C70128', // red
                'tertiary-light': '#C70128', // red
                'tertiary-dark': '#C70128', // red
                black: '#000000', // black
                'black-light': '#566989', // light black
                teal: '#C70128', // red
                'pastel-blue': '#C70128', // red
            },
        },
    },
};
export default {
    assets,
    displayName,
    name,
    primitives,
    socials,
    type,
};
